<!-- /* eslint-disable @angular-eslint/template/no-negated-async */ -->
<div class="inventory-page-container">
  <form class="table-controls-container" [formGroup]="inventoryControlsForm">
    <div class="header-container">
      <div class="text-title-2">Inventory</div>
      <div class="sub-header">
        There are
        <div class="bold">{{uniqueNDCsNumber}}</div>
        unique NDCs on-hand
      </div>
    </div>

    <div class="table-controls">
      <app-search-input formControlName="searchValue"
                        [color]="SearchInputColorEnum.Green"
                        [hideDropdown]="true"
                        [placeholder]="'Search by drug name, NDC or GPI'"
                        [loading]="isLoading$ | async"
                        [hasError]="inventoryControlsForm.get('searchValue').value && !inventoryActiveListFiltered?.length"
      ></app-search-input>
      <app-schedules-filter *ngIf="enableC3toC5Drugs$ | async"
        class="schedules"
        [selectedItemsBadgeLimitCount]="3"
        [control]="inventoryControlsForm.controls.schedules">
      </app-schedules-filter>
      <app-inventory-locations-filter *ngIf="inventoryLocationsEnabled$ | async"
        [control]="inventoryControlsForm.controls.inventoryLocations">
      </app-inventory-locations-filter>
    </div>
  </form>

  <app-tabs (tabSelected)="tabChanged($event)" [tabsMarginLeft]="'32px'">
    <app-tab [tabValue]="InventoryTablesEnum.Active"
             [count]="inventoryActiveListFiltered?.length"
             [tabTitle]="'Active'"
             [active]="currentTab === InventoryTablesEnum.Active"
    >
      <app-inventory-empty-splash *ngIf="(isLoading$ | async) !== true && !inventoryActiveListFiltered?.length && !inventoryControlsForm.get('searchValue').value"
                                  [message]="'You haven’t added any active inventory yet.'"
      ></app-inventory-empty-splash>
      <app-inventory-table *ngIf="inventoryActiveListFiltered?.length"
                           (ndcArchived)="afterNDCArchived($event, true)"
                           [inventoryList]="inventoryActiveListFiltered"
      ></app-inventory-table>
      <app-search-empty-splash *ngIf="(isLoading$ | async) !== true && !inventoryActiveListFiltered?.length && inventoryControlsForm.get('searchValue').value"
                               [searchValue]="inventoryControlsForm.get('searchValue').value"
      ></app-search-empty-splash>
    </app-tab>

    <app-tab *ngIf="false"
             [tabValue]="InventoryTablesEnum.Archived"
             [count]="inventoryArchivedListFiltered?.length"
             [tabTitle]="'Archived'"
             [active]="currentTab === InventoryTablesEnum.Archived"
    >
      <app-inventory-empty-splash *ngIf="(isLoading$ | async) !== true && !inventoryArchivedList?.length"
                                  [message]="'You haven’t added any archived inventory yet.'"
      ></app-inventory-empty-splash>
      <app-inventory-archived-table *ngIf="inventoryArchivedListFiltered.length"
                                    (ndcUnArchived)="afterNDCArchived($event, false)"
                                    [inventoryList]="inventoryArchivedListFiltered"
      ></app-inventory-archived-table>
      <app-search-empty-splash
        *ngIf="(isLoading$ | async) !== true && inventoryArchivedList.length && !inventoryArchivedListFiltered.length"
        [searchValue]="inventoryControlsForm.get('searchValue').value"
      ></app-search-empty-splash>
    </app-tab>
  </app-tabs>
</div>